import { Controller } from "stimulus"
// import Slim from "./slim"

export default class extends Controller {

  static targets = [ "input", "lockee", "locker" ]
  static values = { locked: Boolean }

  initialize() {
    import("./slim").then((slim) => {
      this.slim = slim.default
      this.inputTargets.forEach((el) =>  {
        this.slim.parse(el.parentNode)

        if (this.lockedValue) {
          this.removeSlim(el)
        }
      })
    })
  }

  toggleLocked(e) {
    this.lockedValue = !e.currentTarget.checked
  }

  removeSlim(el) {
    let slim = this.slim.find(el)

    if (slim) {
      slim.remove()
    }
  }

  lockedValueChanged() {
    this.lockeeTargets.forEach((el) => {
      if (this.lockedValue) {
        el.classList.add("locked")
      } else {
        el.classList.remove("locked")
      }
    })

    if (typeof this.slim != "undefined") {
      if (this.lockedValue) {
        this.inputTargets.forEach((el) => {
          this.removeSlim(el)
        })
      }
    }
  }
}